import { Button } from '@mui/material'
import React from 'react'
import { auth } from '../../firebase'
import "./Auth.css"

const SignOut = () => {
  return (
    <div className='signOut'>
        <Button onClick={() => auth.signOut()} className='signOutButton'>
            サインアウト
        </Button>
    </div>
  )
}

export default SignOut